import { Typography } from "@mui/material";
import React, { FC } from "react";

interface LibraryCardDetailRowProps {
  label: string;
  value: JSX.Element;
}

export const LibraryCardDetailRow: FC<LibraryCardDetailRowProps> = ({
  label,
  value,
}) => {
  return (
    <div className="flex flex-row w-full justify-between">
      <Typography color="secondary">{label}</Typography>
      <Typography className="text-right flex-1">{value}</Typography>
    </div>
  );
};
